import { API_QUERY_PARAMS, type DirectMessagesReportResponse, type GetDirectMessagesParams } from '@/types';
import { ApiService } from './api.service';

class DirectMessagesService extends ApiService {
  public async getDirectMessages(
    churchId: string,
    params: GetDirectMessagesParams = {}
  ): Promise<DirectMessagesReportResponse> {
    const queryParams = new URLSearchParams();

    if (params.cursor) queryParams.append(API_QUERY_PARAMS.CURSOR, params.cursor);
    if (params.limit) queryParams.append(API_QUERY_PARAMS.LIMIT, params.limit.toString());

    const queryString = queryParams.toString();
    const url = `/api/v1/churches/${churchId}/direct-messages${queryString ? `?${queryString}` : ''}`;
    const response = await this.get<DirectMessagesReportResponse>(url);
    return response.data;
  }

  public async exportDirectMessageReport(churchId: string, reportId: string): Promise<Blob> {
    const url = `/api/v1/churches/${churchId}/direct-messages/${reportId}/export`;
    return this.getBlob(url);
  }
}

export const directMessagesService = new DirectMessagesService();
